(() => {
  const start = () => {
    const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    const cartRoot = window.Shopify?.routes?.root || '/';
    const update = async () => {
      let cart;
      try {
        const response = await fetch(cartRoot + 'cart.js', { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        cart = await response.json();
      } catch {
        return;
      }
      const actualDiscount = Number(cart.total_discount) || 0;
      document.querySelectorAll('[data-mys-multiunit-progress]').forEach((node) => {
        const title = node.querySelector('[data-mys-multiunit-title]');
        const detail = node.querySelector('[data-mys-multiunit-detail]');
        if (!title || !detail) return;
        node.hidden = false;
        if (actualDiscount > 0) {
          title.textContent = money.format(actualDiscount / 100) + ' in Cart Discounts Applied';
          detail.textContent = 'This is the discount applied by Shopify to your current cart.';
        } else {
          title.textContent = 'Your Cart';
          detail.textContent = 'Eligible discounts are calculated at checkout.';
        }
      });
    };
    update();
    document.addEventListener('visibilitychange', () => { if (!document.hidden) update(); });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, update);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

